import { Phone, Mail, MapPin, MessageCircle, Clock } from "lucide-react";
import { waLink, PHONE, EMAIL } from "../lib/api";
import { Reveal, Eyebrow } from "../components/Reveal";
import { EnquiryForm } from "../components/EnquiryModal";
import { useTitle } from "../hooks/useTitle";

const INFO = [
  { icon: Phone, label: "Call Us", value: PHONE, href: "tel:+919076400577", testid: "contact-phone" },
  { icon: MessageCircle, label: "WhatsApp", value: PHONE, href: waLink(), testid: "contact-whatsapp" },
  { icon: Mail, label: "Email", value: EMAIL, href: `mailto:${EMAIL}`, testid: "contact-email" },
  { icon: MapPin, label: "Visit Us", value: "First Floor, Unnat Nagar No.03, M G Road, Goregaon West, Mumbai", testid: "contact-address" },
  { icon: Clock, label: "Counselling Hours", value: "Mon – Sat, 10:00 AM – 7:00 PM", testid: "contact-hours" },
];

export default function Contact() {
  useTitle("Contact Us");
  return (
    <div data-testid="contact-page">
      <section className="bg-[#0A192F] relative overflow-hidden py-16 lg:py-24">
        <div className="absolute inset-0 hero-grid" />
        <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <Eyebrow light>Contact</Eyebrow>
          <h1 className="font-display font-extrabold tracking-tight text-white text-3xl sm:text-4xl lg:text-5xl mt-4 max-w-2xl leading-[1.1]">
            Talk to a counsellor today.
          </h1>
          <p className="mt-5 text-slate-300 text-base max-w-xl leading-relaxed">
            Questions about courses, batches, fees or our professional services? Reach out — we respond fast.
          </p>
        </div>
      </section>

      <section className="py-16 lg:py-20 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-[1fr_1fr] gap-12">
        <div className="space-y-4">
          {INFO.map((item, i) => (
            <Reveal key={item.label} delay={i * 0.06}>
              <a
                href={item.href || "#"}
                target={item.href?.startsWith("http") ? "_blank" : undefined}
                rel="noreferrer"
                data-testid={item.testid}
                className="flex items-center gap-4 bg-white rounded-2xl border border-slate-200 p-5 hover:border-[#0F5132]/50 hover:shadow-md transition-all"
              >
                <div className="w-11 h-11 rounded-xl bg-[#E8F5E9] flex items-center justify-center shrink-0">
                  <item.icon size={18} className="text-[#0F5132]" />
                </div>
                <div>
                  <p className="text-xs font-semibold text-[#627D98]">{item.label}</p>
                  <p className="font-display font-bold text-[#0A192F] text-sm mt-0.5">{item.value}</p>
                </div>
              </a>
            </Reveal>
          ))}
        </div>
        <Reveal delay={0.1}>
          <div className="bg-white rounded-2xl border-2 border-[#C59B27]/60 p-6 sm:p-8 shadow-lg" data-testid="contact-form-card">
            <h2 className="font-display font-extrabold text-xl text-[#0A192F] mb-5">Send an Enquiry</h2>
            <EnquiryForm source="contact-page" />
          </div>
        </Reveal>
      </section>
    </div>
  );
}
